import { DsSynopticsGenericObject } from './ds-synoptics-generic-object';
import { DsSynopticsItem } from './ds-synoptics-item';
import { DsSynopticsMainItemInterface } from '../interfaces/ds-synoptics-main-item.interface';

/**
 * Main item of a synoptics, contains a list of items. Can contain a main lane, its children being items.
 */
export class DsSynopticsMainItem extends DsSynopticsGenericObject {
  /**
   * List of items.
   */
  public items?: DsSynopticsItem[];

  /**
   * Creates an instance of DsSynopticsMainItem.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsSynopticsMainItemInterface) {
    super(jsonData);
    if (!jsonData) {
      return;
    }
    this.items = jsonData.items ? jsonData.items.map((row) => new DsSynopticsItem(row)) : [];
  }
}
